import axios from "axios";

export const serviceCrearRol = () => {
  const create = async (data) => {
    const endpoint = `${process.env.REACT_APP_BASE_URL_ROLES}/roles`;

    try {
      const result = await axios.post(endpoint, {
        ...data,
      });
      return result;
    } catch (error) {
      const { response } = error;
      return response;
    }
  };
  return { create };
};
